// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveTradePartnerAvailabilityRequestMutationVariables = Types.Exact<{
  input: Types.SaveTradePartnerAvailabilityRequestInput;
}>;


export type SaveTradePartnerAvailabilityRequestMutation = { __typename?: 'Mutation', saveTradePartnerAvailabilityRequest: { __typename?: 'SaveTradePartnerAvailabilityRequestResult', tradePartnerAvailabilityRequest: { __typename?: 'TradePartnerAvailabilityRequest', id: string, emails: Array<{ __typename?: 'TradePartnerAvailabilityRequestEmail', id: string, subject: string, message: string }>, internalUser: { __typename?: 'InternalUser', id: string, name: string }, tradePartnerContacts: Array<{ __typename?: 'TradePartnerContact', email?: string | null | undefined, id: string, name: string }> } } };

export type TradePartnerAvailabilityRequest_TradePartnerEmailFragment = { __typename?: 'TradePartnerAvailabilityRequestEmail', id: string, subject: string, message: string };

export const TradePartnerAvailabilityRequest_TradePartnerEmailFragmentDoc = gql`
    fragment TradePartnerAvailabilityRequest_TradePartnerEmail on TradePartnerAvailabilityRequestEmail {
  id
  subject
  message
}
    `;
export const SaveTradePartnerAvailabilityRequestDocument = gql`
    mutation SaveTradePartnerAvailabilityRequest($input: SaveTradePartnerAvailabilityRequestInput!) {
  saveTradePartnerAvailabilityRequest(input: $input) {
    tradePartnerAvailabilityRequest {
      id
      emails {
        ...TradePartnerAvailabilityRequest_TradePartnerEmail
      }
      internalUser {
        ...Named
      }
      tradePartnerContacts {
        ...Named
        email
      }
    }
  }
}
    ${TradePartnerAvailabilityRequest_TradePartnerEmailFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useSaveTradePartnerAvailabilityRequestMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerAvailabilityRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerAvailabilityRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerAvailabilityRequestMutation, { data, loading, error }] = useSaveTradePartnerAvailabilityRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerAvailabilityRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerAvailabilityRequestMutation, SaveTradePartnerAvailabilityRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerAvailabilityRequestMutation, SaveTradePartnerAvailabilityRequestMutationVariables>(SaveTradePartnerAvailabilityRequestDocument, options);
      }
export type SaveTradePartnerAvailabilityRequestMutationHookResult = ReturnType<typeof useSaveTradePartnerAvailabilityRequestMutation>;
export type SaveTradePartnerAvailabilityRequestMutationResult = ApolloReactCommon.MutationResult<SaveTradePartnerAvailabilityRequestMutation>;